import DictionaryTable from './DictionaryTable'
export default DictionaryTable
